let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("euA5f")).then(() => parcelRequire('bZz8I'));